import { filterOptions } from '@/utils/query-base'

const city = filterOptions(['EQ', 'EMPTY', 'NEMPTY', 'NE'])
// const all = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'BT', 'GT', 'LT', 'LE', 'GE'])
// const cusname = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'CP-S'])

export default {
  'zzfld000001': {
    describe: true,
    title: '营销单元',
    type: 'select',
    dictionary: 'sale'
  },
  'ycate': {
    describe: true,
    title: '品牌(月报分类)',
    type: 'select',
    equation: city,
    dictionary: 'A0016'
  },
  'sale_dun1': {
    title: '销量(吨)',
    width: 150,
    xlsxFmt: {
      t: 'n',
      z: '0.00000000'
    }
  },
  'sale_money1': {
    title: '销售额(万元)',
    width: 150,
    xlsxFmt: {
      t: 'n',
      z: '0.000000'
    }
  },
  'sale_dun2': {
    title: '销量(吨)',
    width: 150,
    xlsxFmt: {
      t: 'n',
      z: '0.00000000'
    }
  },
  'sale_money2': {
    title: '销售额(万元)',
    width: 150,
    xlsxFmt: {
      t: 'n',
      z: '0.000000'
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/report-forms-manage/config/liquorSalesCompanyReportForms2.js